export default __webpack_public_path__ + "static/media/dustbg.dd226157.jpg";